import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { IdlePreload } from '@angularclass/idle-preload';

import { NoContentComponent } from './no-content';


export const routes: Routes = [
  { path: '', redirectTo: 'domains', pathMatch: 'full' },
  { path: '**', component: NoContentComponent },
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: false, preloadingStrategy: IdlePreload });
//




// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/app.routes.ts